import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    // ------------------------------------------------------------
    // Add Receive Money as virtual match
    // ------------------------------------------------------------

    addMatch(event) {
        event.preventDefault()

        const form = this.element.querySelector("form")
        if (!form) return

        const total = parseFloat(
            form.querySelector("[name='receipt[total_amount]']")?.value || 0
        )

        const clientName = this.getComboboxLabel("receipt[client_id]")

        const item = {
            type: "Finance::Receipt",
            id: `receipt-${Date.now()}`,   // unique temp id
            title: "Receive Money",
            subtitle: clientName,
            amount: total,
            payload: this.serializeForm(form)
        }

        // Reset form for next entry
        this.resetForm(form)

        // Send to Selected Matches panel
        this.dispatch("add", { detail: item })
    }

    getComboboxLabel(fieldName) {
        const hidden = this.element.querySelector(
            `input[type="hidden"][name="${fieldName}"]`
        )

        if (!hidden) return ""

        const fieldset = hidden.closest(".hw-combobox")
        if (!fieldset) return ""

        const selected = fieldset.querySelector(
            '[role="option"][aria-selected="true"]'
        )

        return selected?.textContent?.trim() || ""
    }

    // ------------------------------------------------------------
    // Serialize form data
    // ------------------------------------------------------------

    serializeForm(form) {
        const payload = {
            account_id: form.querySelector("[name='receipt[account_id]']")?.value,
            client_id: form.querySelector("[name='receipt[client_id]']")?.value,
            receipt_date: form.querySelector("[name='receipt[receipt_date]']")?.value,
            payment_method_id: form.querySelector("[name='receipt[payment_method_id]']")?.value,
            reference: form.querySelector("[name='receipt[reference]']")?.value || "",
            total_amount: parseFloat(
                form.querySelector("[name='receipt[total_amount]']")?.value || 0
            ),
            receipt_allocations_attributes: {}
        }

        // ------------------------------------------------------------
        // Allocation lines
        // ------------------------------------------------------------

        const lines = form.querySelectorAll(".allocation-line")

        lines.forEach((line, index) => {
            const accountId = line.querySelector(
                "select[name*='[account_id]']"
            )?.value

            const amount = parseFloat(
                line.querySelector("input[name*='[amount]']")?.value || 0
            )

            const description =
                line.querySelector("input[name*='[description]']")?.value || ""

            if (accountId && amount > 0) {
                payload.receipt_allocations_attributes[index] = {
                    account_id: accountId,
                    amount: amount,
                    description: description
                }
            }
        })

        return payload
    }

    // ------------------------------------------------------------
    // Reset form to original state
    // ------------------------------------------------------------

    resetForm(form) {
        // Reset native fields
        form.reset()

        form.querySelector("[name='receipt[client_id]']").value = null

        // Remove allocation lines
        const container = form.querySelector(
            "[data-finance-receipt-receive-target='container']"
        )

        if (container) container.innerHTML = ""

        // Recalculate totals via receipt controller
        const receiptController =
            this.application.getControllerForElementAndIdentifier(
                form,
                "finance-receipt-receive"
            )

        if (receiptController) {
            receiptController.recalculate()
            receiptController.valid()
        }
    }
}
